import { Component, EventEmitter, Output } from '@angular/core';
import { HlmItemImports } from "@spartan-ng/helm/item";
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { NgIcon, provideIcons } from "@ng-icons/core";
import { matArrowForwardOutline } from '@ng-icons/material-symbols/outline';
import { lucideCreditCard, lucideFilePenLine, lucidePhone, lucideVerified } from '@ng-icons/lucide';
import { RouterLink } from '@angular/router';

interface process {
  title:string
  description:string
  icon:string
}

@Component({
  selector: 'app-welcome-step',
  imports: [HlmItemImports,HlmButtonImports, NgIcon,RouterLink],
  templateUrl: './welcome-step.html',
  styleUrl: './welcome-step.css',
  providers: [provideIcons({matArrowForwardOutline,lucideCreditCard,lucideFilePenLine ,lucideVerified,lucidePhone})]
  // host: {
})
export class WelcomeStep {

  @Output() onContinue = new EventEmitter<any>

  processes:process[]=[
    {
      title:'Complete the Application Form',
      description:'Fill in your personal details, contact information, state of origin, referee particulars, and upload your passport photograph and signature.',
      icon:'lucideFilePenLine',
    },
    {
      title: 'Make the Payment',
      description:'Pay the application fee securely via Mobile Money (MTN, Telecel, AirtelTigo). A confirmation receipt is generated instantly.',
      icon:'lucideCreditCard'
    },
    {
      title: 'Verification & Status Check',
      description:'Once payment is confirmed, your membership application is submitted for verification. You can track its status at any time from the confirmation screen.',
      icon:'lucideVerified'
    }
  ]

  continue(): void {
    this.onContinue.emit(true)
  }
}
